import { LoginDto } from "types/dto";
import { ApiService } from "./apiService";
import { ChangePasswordDto } from "types/dto/ChangePasswordDto";
import { VerifyEmailDto } from "types/dto/VerifyEmailDto";
import { ResetPasswordDto } from "types/dto/ResetPasswordDto";
import { RegisterDto } from "types/dto/RegisterDto";
import { VerifyAccountDto } from "types/dto/VerifyAccountDto";

export const login = async (credentials: LoginDto) => {
  try {
    return await ApiService.post('login', credentials);
  } catch (error) {
    throw error;
  }
}

export const logout = async () => {
  return await ApiService.post(`logout`, {});
}

export const changePassword = async (userId: number, dto: ChangePasswordDto) => {
  return await ApiService.post(`users/${userId}/change_password`, dto);
}

export const forgetPassword = async (email: string) => {
  return await ApiService.post(`forget_password`, {
    email,
  });
}

export const isValidVerificationCode = async (dto: VerifyEmailDto) => {
  return await ApiService.post(`verify_email`, dto);
}

export const resetPassword = async (dto: ResetPasswordDto) => {
  return await ApiService.post(`reset_password`, dto);
}

export const signup = async (dto: RegisterDto) => {
  return await ApiService.post(`registration`, dto);
}

export const resendVerificationCode = async (userId: number) => {
  return await ApiService.get(`users/${userId}/verification_resend`);
}

export const verifyAccount = async (dto: VerifyAccountDto, userId: number) => {
  return await ApiService.post(`users/${userId}/verification`, dto);
}

export const isEmailAvailable = async (email: string) => {
  const { data } = await ApiService.get(`users/check-email?email=${email}`);
  return data;
}

export const deleteAccount = async (userId: number) => {
  return await ApiService.delete(`users/${userId}`);
}

const getOrCreateDeviceUuid = (): string => {
  let uuid = localStorage.getItem('deviceUuid');
  if (!uuid) {
    uuid = crypto.randomUUID();
    localStorage.setItem('deviceUuid', uuid);
  }
  return uuid;
};

export const registerForPushNotifications = async (pushToken: string) => {
  try {
    const uuid = getOrCreateDeviceUuid();

    return await ApiService.post('user_devices', {
      push_token: pushToken,
      device_uuid: uuid,
      device_name: 'Web Browser',
      device_os: 'WEB',
      os_version: navigator.userAgent,
      device_model: navigator.userAgent,
    });
  } catch (error) {
    console.error('Failed to register for push notifications:', error);
  }
};

export const unRegisterForPushNotifications = async () => {
  try {
    const uuid = localStorage.getItem('deviceUuid');
    if (uuid) {
      await ApiService.delete(`user_devices/${uuid}`);
    }
  } catch (error) {
    console.error('Failed to unregister push notifications:', error);
  }
};